import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { changeRepeat, changeRepeatFrequency, changeRepeatUntil } from 'booking/actions';
import RepeatBooking from 'booking/components/RepeatBooking';

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ changeRepeatFrequency, changeRepeatUntil, changeRepeat }, dispatch);
}

function mapStateToProps(state) {
  const { addedServices, client, isEditBooking, frequency, until } = state.booking;
  if (client) {
    const { id } = client;
    return { addedServices, clientId: id, isEditBooking, frequency, until };
  }

  return { addedServices, isEditBooking };
}

export default connect(mapStateToProps, mapDispatchToProps)(RepeatBooking);
